// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1AD6F","choiceBoxes":"toolbarselects_choiceBoxes__2GYhs","simpleField":"toolbarselects_simpleField__3Gi0v"};